import React from "react";
import { Button, Modal } from "react-bootstrap";
import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function AnswersDetailsModal({
  answers,
  showAnswerDetails,
  setShowAnswerDetails,
  item,
}) {
  return (
    <Modal
      show={showAnswerDetails}
      onHide={() => setShowAnswerDetails(false)}
      centered
    >
      <Modal.Header>
        <h5>
          {item.feature ? item.feature.name + " " : ""}
          {item.name}
          &nbsp;
          <span className="text-bold text-muted">
            {turkishCurrencyFormatterNoPrecision(
              item.price + (item.feature ? item.feature.price : 0)
            )}
          </span>
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div
          className="mb-3 p-2 bg-light"
          style={{
            border: "1px solid #ddd",
            borderRadius: "5px",
            position: "relative",
          }}
        >
          {answers.map((answer) => (
            <div className="p-1 ">
              <span className={"text-bold"}>{answer.question}</span>
              <ul>
                {answer.answers.map((a, i) => (
                  <li key={a._id || i}>
                    {a.answer}
                    <span className="text-bold">
                      &nbsp;{" "}
                      {!!a.cost && turkishCurrencyFormatterNoPrecision(a.cost)}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="dark"
          size="lg"
          onClick={() => setShowAnswerDetails(false)}
          style={{ width: "100%" }}
        >
          Kapat
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
